var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "7swp2xsgca",
    x1: "46.359%",
    x2: "768.084%",
    y1: "60.824%",
    y2: "-1631.266%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lw78quuxdb",
    x1: "102.335%",
    x2: "669.414%",
    y1: "-74.607%",
    y2: "-1432.463%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1fkm45qrvc",
    x1: "129.502%",
    x2: "646.868%",
    y1: "-134.724%",
    y2: "-1373.553%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "5ae5n6fm3d",
    x1: "150.685%",
    x2: "615.397%",
    y1: "-186.041%",
    y2: "-1298.785%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8wu5l9h73e",
    x1: "82.079%",
    x2: "798.07%",
    y1: "-20.871%",
    y2: "-1750.368%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ikt3c8ma0f",
    x1: "116.023%",
    x2: "747.8%",
    y1: "-105.584%",
    y2: "-1618.374%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezjy1mx3bg",
    x1: "114.711%",
    x2: "745.704%",
    y1: "-104.698%",
    y2: "-1613.945%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u2ytumiorh",
    x1: "149.15%",
    x2: "717.187%",
    y1: "-181.24%",
    y2: "-1541.415%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dzaen6gmzi",
    x1: "184.71%",
    x2: "713.697%",
    y1: "-260.235%",
    y2: "-1526.896%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dhixael7kj",
    x1: "210.111%",
    x2: "680.953%",
    y1: "-319.962%",
    y2: "-1440.928%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sndx008nnk",
    x1: "97.13%",
    x2: "796.946%",
    y1: "-59.546%",
    y2: "-1735.241%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xq2wcosfel",
    x1: "138.785%",
    x2: "778.899%",
    y1: "-156.834%",
    y2: "-1689.011%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uer715rojm",
    x1: "177.685%",
    x2: "752.939%",
    y1: "-244.121%",
    y2: "-1621.573%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "61gn3d6gan",
    x1: "212.443%",
    x2: "734.709%",
    y1: "-325.153%",
    y2: "-1575.684%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "udbxze7zmo",
    x1: "240.001%",
    x2: "704.82%",
    y1: "-390.371%",
    y2: "-1499.243%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zpmbttj2tp",
    x1: "47.859%",
    x2: "844.068%",
    y1: "50.644%",
    y2: "-1884.86%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qe03ykg6cq",
    x1: "98.969%",
    x2: "814.046%",
    y1: "-62.251%",
    y2: "-1774.491%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b7xcmz52or",
    x1: "141.577%",
    x2: "787.023%",
    y1: "-162.256%",
    y2: "-1700.293%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q0b3vzp86s",
    x1: "180.683%",
    x2: "754.349%",
    y1: "-251.284%",
    y2: "-1624.923%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3b1a68mk2t",
    x1: "215.689%",
    x2: "736.874%",
    y1: "-333.717%",
    y2: "-1576.875%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t7dmpek1pu",
    x1: "249.069%",
    x2: "718.054%",
    y1: "-408.855%",
    y2: "-1531.855%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qim4v6swlv",
    x1: "33.936%",
    x2: "835.361%",
    y1: "88.663%",
    y2: "-1866.521%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pjrk7akrxw",
    x1: "79.91%",
    x2: "805.744%",
    y1: "-23.208%",
    y2: "-1780.882%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fkrd7k4mzx",
    x1: "121.929%",
    x2: "768.662%",
    y1: "-123.981%",
    y2: "-1705.934%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xm332ooevy",
    x1: "160.09%",
    x2: "734.352%",
    y1: "-205.626%",
    y2: "-1580.718%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s0jg2f5evz",
    x1: "192.968%",
    x2: "708.292%",
    y1: "-282.644%",
    y2: "-1516.59%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2aab4h8ddA",
    x1: "223.734%",
    x2: "690.85%",
    y1: "-359.641%",
    y2: "-1487.157%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "4976oynq8B",
    x1: "4.762%",
    x2: "793.583%",
    y1: "153.077%",
    y2: "-1706.588%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2fusufrsdC",
    x1: "46.166%",
    x2: "783.292%",
    y1: "58.6%",
    y2: "-1706.444%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b47xnw1sxD",
    x1: "83.883%",
    x2: "720.513%",
    y1: "-31.44%",
    y2: "-1564.592%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "og787dbtxE",
    x1: "118.67%",
    x2: "685.884%",
    y1: "-106.181%",
    y2: "-1457.647%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cg1jv2b6mF",
    x1: "148.448%",
    x2: "665.522%",
    y1: "-173.975%",
    y2: "-1383.712%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jy1e9sbohG",
    x1: "177.743%",
    x2: "642.463%",
    y1: "-241.573%",
    y2: "-1349.996%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gl7mvy1xbH",
    x1: "-33.241%",
    x2: "764.602%",
    y1: "247.78%",
    y2: "-1683.849%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uy93d2ef7I",
    x1: "-.338%",
    x2: "709.275%",
    y1: "163.749%",
    y2: "-1521.571%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3yc77b0psJ",
    x1: "32.067%",
    x2: "663.851%",
    y1: "89.97%",
    y2: "-1424.525%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bbwxkndwsK",
    x1: "60.983%",
    x2: "629.166%",
    y1: "27.981%",
    y2: "-1324.092%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ggjyljtpwL",
    x1: "86.184%",
    x2: "611.18%",
    y1: "-32.666%",
    y2: "-1289.763%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1yjdxty4sM",
    x1: "107.938%",
    x2: "571.713%",
    y1: "-83.716%",
    y2: "-1194.18%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gc69cz693N",
    x1: "-79.114%",
    x2: "718.885%",
    y1: "351.547%",
    y2: "-1559.269%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wlphd5t2fO",
    x1: "-49.41%",
    x2: "645.437%",
    y1: "281.969%",
    y2: "-1369.79%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "14w9p8rlmP",
    x1: "-30.253%",
    x2: "609.901%",
    y1: "238.244%",
    y2: "-1294.586%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i8zpmo8jhQ",
    x1: "-9.393%",
    x2: "562.974%",
    y1: "187.736%",
    y2: "-1175.401%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hwxpwxte3R",
    x1: "7.767%",
    x2: "527.672%",
    y1: "145.991%",
    y2: "-1093.305%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nnsydh8k4S",
    x1: "25.113%",
    x2: "489.833%",
    y1: "108.463%",
    y2: "-1004.309%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xvipfr12hT",
    x1: "-128.093%",
    x2: "668.292%",
    y1: "461.037%",
    y2: "-1445.882%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1veix5kxU",
    x1: "-113.322%",
    x2: "605.965%",
    y1: "428.688%",
    y2: "-1303.24%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g65ur1podV",
    x1: "-98.756%",
    x2: "546.723%",
    y1: "390.602%",
    y2: "-1135.533%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lyphx8mtrW",
    x1: "-86.794%",
    x2: "495.715%",
    y1: "371.579%",
    y2: "-1044.928%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g7wn1aqy2X",
    x1: "-74.425%",
    x2: "446.847%",
    y1: "332.369%",
    y2: "-886.952%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "awa9jh3qlY",
    x1: "-64.404%",
    x2: "404.506%",
    y1: "316.489%",
    y2: "-806.313%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "149li58ayZ",
    x1: "-172.624%",
    x2: "624.897%",
    y1: "563.746%",
    y2: "-1345.856%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z6p2axvntaa",
    x1: "-168.304%",
    x2: "549.463%",
    y1: "545.728%",
    y2: "-1153.739%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "20m3qcz1eab",
    x1: "-161.521%",
    x2: "479.688%",
    y1: "535.129%",
    y2: "-983.037%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fos52uq6hac",
    x1: "-151.432%",
    x2: "412.089%",
    y1: "510.554%",
    y2: "-813.534%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gr4dtgcpzad",
    x1: "-155.082%",
    x2: "366.023%",
    y1: "529.359%",
    y2: "-729.67%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ztngi06l1ae",
    x1: "-205.825%",
    x2: "582.998%",
    y1: "642.882%",
    y2: "-1245.962%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuojdo2jpaf",
    x1: "-216.114%",
    x2: "505.674%",
    y1: "650.824%",
    y2: "-1041.386%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "94elio1poag",
    x1: "-217.197%",
    x2: "427.529%",
    y1: "679.626%",
    y2: "-883.623%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "40fe7wnc4ah",
    x1: "-214.264%",
    x2: "352.849%",
    y1: "662.167%",
    y2: "-689.068%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rhqaubgzzai",
    x1: "-244.276%",
    x2: "465.408%",
    y1: "733.841%",
    y2: "-965.449%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "xpu7qoybjaj",
    x1: "-252.092%",
    x2: "379.661%",
    y1: "752.346%",
    y2: "-760.381%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2whj6c7weak",
    x1: "-258.642%",
    x2: "441.171%",
    y1: "765.201%",
    y2: "-910.491%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i89jks4p2al",
    x1: "-278.041%",
    x2: "362.169%",
    y1: "810.739%",
    y2: "-721.674%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8y5981cnsam",
    x1: "-279.958%",
    x2: "358.974%",
    y1: "795.715%",
    y2: "-698.984%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0D3358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16.48%",
    stopColor: "#0085E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.45%",
    stopColor: "#F9C403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.98%",
    stopColor: "#F9BF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.97%",
    stopColor: "#F7B007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.72%",
    stopColor: "#F5970C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.02%",
    stopColor: "#F17413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91.65%",
    stopColor: "#ED481B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E91C24"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H50V50H0z",
    transform: "translate(-50 -61) translate(50 61)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#7swp2xsgca)",
    d: "M31.594 26.424c.572-.28 1.216-.07 1.502.42.286.561.071 1.192-.43 1.472-.571.28-1.215.07-1.5-.42-.358-.49-.144-1.192.428-1.472z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#lw78quuxdb)",
    d: "M34.668 31.96c.715-.35 1.501-.14 1.93.562.358.7.143 1.471-.572 1.892-.643.35-1.501.14-1.93-.56-.358-.702-.143-1.543.572-1.893z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#1fkm45qrvc)",
    d: "M36.457 35.255c.786-.42 1.716-.14 2.073.631.43.771.143 1.682-.643 2.033-.787.42-1.716.14-2.074-.631-.429-.771-.143-1.682.644-2.033z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#5ae5n6fm3d)",
    d: "M38.457 38.83c.858-.421 1.86-.14 2.36.7.429.841.143 1.822-.715 2.313-.858.42-1.86.14-2.36-.7-.429-.842-.143-1.893.715-2.314z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#8wu5l9h73e)",
    d: "M28.59 27.125c.643-.14 1.216.28 1.287.91.143.632-.286 1.192-.93 1.262-.643.14-1.215-.28-1.286-.91-.072-.561.357-1.192.929-1.262z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ikt3c8ma0f)",
    d: "M29.164 30.069c.715-.14 1.358.35 1.501.981.143.701-.357 1.332-1 1.472-.716.14-1.36-.35-1.502-.981-.143-.701.357-1.402 1-1.472z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ezjy1mx3bg)",
    d: "M33.382 28.877c.715-.14 1.358.35 1.501.981.143.701-.357 1.332-1 1.472-.716.14-1.36-.35-1.502-.981-.143-.701.286-1.332 1-1.472z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#u2ytumiorh)",
    d: "M29.806 33.293c.786-.14 1.501.35 1.644 1.122.143.77-.357 1.471-1.144 1.612-.786.14-1.501-.35-1.644-1.122-.143-.77.357-1.472 1.144-1.612z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dzaen6gmzi)",
    d: "M30.449 36.936c.858-.14 1.644.42 1.787 1.191.143.841-.429 1.612-1.215 1.752-.858.14-1.645-.42-1.788-1.191-.143-.771.43-1.612 1.216-1.752z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dhixael7kj)",
    d: "M31.238 41c.929-.14 1.858.42 2.001 1.332.143.911-.429 1.822-1.358 1.962-.93.14-1.859-.42-2.002-1.331-.215-.911.429-1.822 1.358-1.963z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sndx008nnk)",
    d: "M25.587 26.844c.644.07 1.073.631 1.001 1.262-.071.63-.643 1.051-1.287.981-.643-.07-1.072-.63-1-1.261.142-.631.643-1.052 1.286-.982z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#xq2wcosfel)",
    d: "M25.231 29.788c.715.07 1.144.7 1.073 1.402-.072.7-.715 1.121-1.43 1.05-.715-.07-1.144-.7-1.073-1.4.072-.632.715-1.122 1.43-1.052z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#uer715rojm)",
    d: "M24.73 33.081c.787.07 1.287.771 1.216 1.542-.072.77-.787 1.261-1.573 1.191-.787-.07-1.287-.77-1.216-1.542.143-.77.858-1.261 1.573-1.191z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#61gn3d6gan)",
    d: "M24.23 36.728c.858.14 1.43.84 1.358 1.682-.143.84-.93 1.402-1.716 1.331-.858-.14-1.43-.84-1.358-1.682.143-.84.93-1.401 1.716-1.331z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#udbxze7zmo)",
    d: "M23.728 40.792c.93.14 1.645.981 1.502 1.892-.143.912-1.001 1.612-1.93 1.472-.93-.14-1.645-.981-1.502-1.892.071-.911 1-1.542 1.93-1.472z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#zpmbttj2tp)",
    d: "M24.015 23.27c.5.21.715.842.5 1.332-.214.49-.857.701-1.358.49-.5-.21-.715-.84-.5-1.33.214-.491.858-.772 1.358-.491z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#qe03ykg6cq)",
    d: "M22.8 25.722c.572.28.787.91.5 1.472-.285.56-.929.77-1.5.49-.573-.28-.787-.91-.501-1.472.286-.56.93-.77 1.501-.49z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b7xcmz52or)",
    d: "M21.514 28.386c.643.28.858 1.051.572 1.612-.286.63-1.073.911-1.645.56-.643-.28-.93-1.05-.572-1.611.215-.56 1.001-.841 1.645-.56z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q0b3vzp86s)",
    d: "M20.01 31.399c.715.35 1.001 1.121.644 1.822-.358.7-1.144.981-1.86.63-.714-.35-1-1.12-.643-1.821.358-.701 1.216-.982 1.86-.631z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#3b1a68mk2t)",
    d: "M18.438 34.695c.787.35 1.073 1.262.715 2.032-.357.771-1.287 1.052-2.073.701-.787-.35-1.073-1.261-.715-2.032.357-.701 1.287-1.051 2.073-.701z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t7dmpek1pu)",
    d: "M16.578 38.408c.858.42 1.215 1.402.786 2.243-.429.84-1.43 1.191-2.288.77-.858-.42-1.215-1.401-.786-2.242.429-.841 1.43-1.192 2.288-.771z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#qim4v6swlv)",
    d: "M22.37 21.8c.43.35.43.98.072 1.4-.358.421-1.001.421-1.43.071-.43-.35-.43-.981 0-1.402.357-.42 1-.49 1.358-.07z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pjrk7akrxw)",
    d: "M20.512 23.76c.43.42.5 1.122.072 1.542-.43.42-1.144.49-1.573.07-.429-.42-.5-1.121-.072-1.542.43-.49 1.144-.49 1.573-.07z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fkrd7k4mzx)",
    d: "M18.438 25.933c.5.49.5 1.262.071 1.752-.5.49-1.287.49-1.787.07-.501-.49-.501-1.261-.072-1.752.5-.56 1.287-.56 1.788-.07z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#xm332ooevy)",
    d: "M16.08 28.317c.571.49.571 1.402.07 1.963-.5.56-1.43.56-2.001.07-.572-.491-.572-1.402-.072-1.963.572-.56 1.43-.56 2.002-.07z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s0jg2f5evz)",
    d: "M13.503 30.979c.644.56.644 1.542.072 2.172-.572.631-1.573.631-2.217.07-.643-.56-.643-1.541-.071-2.172.572-.63 1.573-.63 2.216-.07z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#2aab4h8ddA)",
    d: "M10.643 33.992c.715.63.715 1.682.072 2.383-.644.7-1.716.7-2.431.07-.715-.63-.715-1.682-.072-2.383.644-.7 1.716-.77 2.431-.07z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#4976oynq8B)",
    d: "M21.37 19.906c.286.49.071 1.121-.43 1.332-.5.28-1.143.07-1.358-.42-.286-.492-.071-1.122.43-1.333.5-.21 1.072-.07 1.358.421z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#2fusufrsdC)",
    d: "M18.939 21.167c.286.561.071 1.192-.43 1.472-.571.28-1.215.07-1.5-.42-.287-.561-.072-1.192.428-1.472s1.216-.07 1.502.42z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b47xnw1sxD)",
    d: "M16.292 22.64c.357.631.071 1.332-.501 1.682-.643.35-1.358.07-1.716-.49-.357-.631-.071-1.332.5-1.682.573-.35 1.359-.14 1.717.49z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#og787dbtxE)",
    d: "M13.29 24.18c.358.63.143 1.472-.572 1.893-.643.35-1.501.14-1.93-.561-.358-.631-.143-1.472.572-1.893.715-.35 1.573-.07 1.93.561z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cg1jv2b6mF)",
    d: "M10 25.933c.429.771.143 1.683-.644 2.033-.786.42-1.715.14-2.073-.63-.429-.632-.143-1.613.572-1.963.787-.42 1.716-.14 2.145.56z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#jy1e9sbohG)",
    d: "M6.284 27.896c.429.841.143 1.822-.715 2.313-.858.42-1.859.14-2.36-.7-.428-.842-.142-1.823.716-2.314.858-.42 1.93-.07 2.359.701z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gl7mvy1xbH)",
    d: "M20.941 17.803c.071.56-.286 1.052-.787 1.192-.572.07-1.072-.28-1.215-.771-.072-.56.286-1.052.786-1.192.644-.14 1.144.21 1.216.771z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#uy93d2ef7I)",
    d: "M18.294 18.292c.143.63-.286 1.192-.93 1.262-.643.14-1.215-.28-1.287-.911-.143-.631.286-1.192.93-1.262.572-.07 1.144.28 1.287.911z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#3yc77b0psJ)",
    d: "M15.291 18.855c.143.701-.357 1.332-1 1.472-.716.14-1.36-.35-1.502-.981-.143-.7.357-1.332 1-1.472.716-.14 1.36.28 1.502.981z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bbwxkndwsK)",
    d: "M11.93 19.415c.143.77-.357 1.472-1.144 1.612-.786.14-1.501-.35-1.644-1.122-.143-.77.357-1.471 1.144-1.612.786-.07 1.501.421 1.644 1.122z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ggjyljtpwL)",
    d: "M8.212 20.116c.143.84-.429 1.612-1.215 1.752-.858.14-1.645-.42-1.788-1.191-.214-.842.358-1.612 1.216-1.753.858-.21 1.644.35 1.787 1.192z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#1yjdxty4sM)",
    d: "M4.138 20.888c.143.911-.43 1.822-1.359 1.963-1 .14-1.859-.421-2.073-1.402-.143-.911.429-1.822 1.358-1.963 1.001-.14 1.86.42 2.074 1.402z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gc69cz693N)",
    d: "M21.225 15.7c-.071.562-.572.912-1.144.842-.572-.07-.93-.56-.858-1.121.072-.561.572-.912 1.144-.841.572.07.93.56.858 1.12z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wlphd5t2fO)",
    d: "M18.508 15.35c-.071.632-.643 1.052-1.287.982-.643-.07-1.072-.63-1-1.261.07-.631.643-1.052 1.286-.982.644.07 1.144.631 1.001 1.262z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#14w9p8rlmP)",
    d: "M15.506 14.93c-.071.702-.715 1.122-1.43 1.052-.715-.07-1.144-.7-1.072-1.402.071-.7.715-1.121 1.43-1.051.715.14 1.144.77 1.072 1.402z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i8zpmo8jhQ)",
    d: "M12.147 14.51c-.071.77-.786 1.261-1.573 1.191-.786-.07-1.287-.77-1.215-1.542.071-.77.786-1.261 1.573-1.191.786.07 1.358.77 1.215 1.542z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hwxpwxte3R)",
    d: "M8.427 14.017c-.143.841-.858 1.402-1.716 1.332-.858-.14-1.43-.841-1.359-1.682.143-.841.93-1.402 1.716-1.332.858.07 1.502.841 1.359 1.682z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#nnsydh8k4S)",
    d: "M4.28 13.457c-.142.911-1 1.612-1.93 1.472-.93-.07-1.644-.982-1.501-1.893.143-.91 1-1.612 1.93-1.471.93.14 1.645.98 1.502 1.892z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#xvipfr12hT)",
    d: "M22.226 13.737c-.214.49-.858.7-1.358.49-.5-.21-.715-.84-.5-1.331.214-.49.857-.701 1.358-.49.5.28.715.84.5 1.33z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g1veix5kxU)",
    d: "M19.726 12.618c-.286.56-.93.77-1.502.49s-.786-.911-.5-1.472c.286-.56.929-.77 1.501-.49.5.21.787.91.5 1.472z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g65ur1podV)",
    d: "M16.937 11.284c-.286.63-1.073.84-1.645.56-.643-.28-.858-1.05-.572-1.612.286-.63 1.073-.84 1.645-.56.643.28.93 1.051.572 1.612z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#lyphx8mtrW)",
    d: "M13.934 9.883c-.358.701-1.144.981-1.86.631-.714-.35-1-1.121-.643-1.822.358-.701 1.144-.981 1.86-.631.643.35.929 1.121.643 1.822z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g7wn1aqy2X)",
    d: "M10.502 8.272c-.357.771-1.287 1.051-2.073.701-.787-.35-1.073-1.262-.715-1.962C8.07 6.24 9 5.959 9.787 6.31c.787.28 1.073 1.191.715 1.962z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#awa9jh3qlY)",
    d: "M6.713 6.519c-.43.84-1.43 1.191-2.288.77-.858-.35-1.216-1.4-.787-2.242.43-.841 1.43-1.191 2.288-.77.858.42 1.216 1.4.787 2.242z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#149li58ayZ)",
    d: "M23.728 12.195c-.357.42-1 .42-1.43.07-.429-.35-.429-.981-.071-1.402.357-.42 1-.42 1.43-.07.429.35.429.982.071 1.402z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#z6p2axvntaa)",
    d: "M21.726 10.375c-.429.42-1.144.49-1.573.07-.429-.42-.5-1.122-.071-1.542.429-.42 1.144-.49 1.573-.07.5.35.5 1.05.071 1.542z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#20m3qcz1eab)",
    d: "M19.51 8.272c-.5.49-1.287.49-1.787.07-.5-.49-.5-1.261-.072-1.752.501-.49 1.287-.49 1.788-.07.5.49.572 1.261.071 1.752z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fos52uq6hac)",
    d: "M17.009 6.027c-.5.56-1.43.56-2.002.07-.572-.49-.572-1.401-.072-1.962.5-.56 1.43-.56 2.002-.07.644.56.644 1.402.072 1.962z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gr4dtgcpzad)",
    d: "M14.292 3.434c-.572.631-1.573.701-2.145.07-.643-.56-.643-1.542-.071-2.172.572-.561 1.573-.631 2.216 0 .572.56.644 1.541 0 2.102z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ztngi06l1ae)",
    d: "M25.589 11.216c-.5.28-1.144.07-1.359-.42-.286-.491-.071-1.122.43-1.332.5-.28 1.143-.07 1.358.42.286.421.071 1.052-.43 1.332z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#uuojdo2jpaf)",
    d: "M24.3 8.832c-.572.28-1.215.07-1.501-.42-.286-.561-.072-1.192.429-1.472.572-.28 1.215-.07 1.501.42.358.491.143 1.192-.429 1.472z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#94elio1poag)",
    d: "M22.87 6.17c-.644.35-1.359.07-1.716-.49-.358-.632-.072-1.333.5-1.683.644-.35 1.359-.07 1.716.49.286.631.072 1.402-.5 1.683z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#40fe7wnc4ah)",
    d: "M21.226 3.295c-.643.35-1.501.14-1.93-.56-.358-.631-.143-1.472.572-1.893.715-.35 1.573-.07 1.93.56.358.702.143 1.543-.572 1.893z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#rhqaubgzzai)",
    d: "M27.232 8.132c-.643.14-1.215-.28-1.287-.91-.143-.632.286-1.192.93-1.262.643-.14 1.215.28 1.287.91.143.561-.286 1.192-.93 1.262z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#xpu7qoybjaj)",
    d: "M26.732 5.188c-.715.14-1.359-.35-1.502-.981-.143-.701.358-1.332 1.001-1.472.715-.14 1.359.35 1.502.981.143.701-.358 1.402-1.001 1.472z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#2whj6c7weak)",
    d: "M30.306 8.411c-.644-.07-1.073-.63-1.001-1.262.071-.63.643-1.05 1.287-.98.643.07 1.072.63 1 1.26-.142.632-.714 1.052-1.286.982z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i89jks4p2al)",
    d: "M30.664 5.468c-.715-.07-1.144-.7-1.072-1.402.071-.7.714-1.121 1.43-1.05.715.07 1.143.7 1.072 1.4-.071.632-.715 1.122-1.43 1.052z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#8y5981cnsam)",
    d: "M34.382 6.87c-.643-.28-.858-1.051-.572-1.612.286-.63 1.073-.84 1.645-.56.643.21.93.98.643 1.612-.357.63-1.072.84-1.716.56z",
    transform: "translate(-50 -61) translate(50 61) translate(4.167 2.5)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c7a92404.svg";
export { ForwardRef as ReactComponent };